module.exports = {
  MAX_DAYS_TILL_EXTENSION: 5,
  CAMPAIGN_MIN_BUDGET: 500,
  DEFAULT_JOB_CATEGORY: "L1000_L2000_L3000",
  ONLYFY: "ONLYFY"
};
